export default "__VITE_ASSET__DNK2ZNPG__"